var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHumidity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".primary-text{fill:var(--color--primary-text);}.primary-bg{fill:var(--color--primary-bg);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(448 87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448 -87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary-text",
    d: "M21.01,19.483A11.011,11.011,0,0,1,13.062,8.929a10.864,10.864,0,0,1,1.031-4.62.69.69,0,0,0-.025-.628A32.007,32.007,0,0,0,12.126.531,1.5,1.5,0,0,0,10,.4a1.672,1.672,0,0,0-.131.131C7.844,3.192,0,18.278,0,22.678c0,5.4,5.243,10.312,11,10.312s11-4.916,11-10.312a10.6,10.6,0,0,0-.521-2.728A.69.69,0,0,0,21.01,19.483ZM10.63,28.942A1.029,1.029,0,0,1,9.4,29.72H9.393a7.2,7.2,0,0,1-4.855-3.831,1.031,1.031,0,1,1,1.84-.932l.007.014A5.137,5.137,0,0,0,9.86,27.707,1.032,1.032,0,0,1,10.63,28.942Z",
    transform: "translate(0 0.009)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "primary-text",
    d: "M19.937,0a8.937,8.937,0,1,0,8.937,8.937A8.937,8.937,0,0,0,19.937,0Z",
    transform: "translate(4.125)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-429.537 -84.036)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary-bg",
    d: "M13.428,4.759a2.358,2.358,0,0,1,2.4-2.6,2.327,2.327,0,0,1,2.368,2.6v.307a2.4,2.4,0,0,1-2.408,2.626,2.35,2.35,0,0,1-2.361-2.626Zm5.494,2.6L22.6,2.551a.741.741,0,0,1,1.023-.257.628.628,0,0,1,.4.555.9.9,0,0,1-.242.628L20.115,8.166,16.1,13.4a.745.745,0,0,1-1.031.25.635.635,0,0,1-.386-.516.9.9,0,0,1,.234-.668ZM15.1,5.009c0,.829.274,1.288.716,1.288s.709-.459.709-1.288V4.823c0-.83-.274-1.273-.709-1.273-.451,0-.716.434-.716,1.273Zm5.486,5.622a2.36,2.36,0,0,1,2.409-2.6,2.321,2.321,0,0,1,2.361,2.6v.307a2.39,2.39,0,0,1-2.4,2.626,2.351,2.351,0,0,1-2.369-2.626Zm1.668.25c0,.83.282,1.29.716,1.29s.709-.459.709-1.29V10.7c0-.829-.265-1.272-.709-1.272s-.716.434-.716,1.272Z",
    transform: "translate(-13.428 -2.156)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHumidity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/humidity.ce3a1f40.svg";
export { ForwardRef as ReactComponent };